import modalTemplate from './view.html';

import { GroupModalController } from './controller';

import { GROUP_MODAL_CONTROLLER } from '../../const';

class GroupModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    open = (groupId, parentGroupId) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: GROUP_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'md',
            resolve: {
                groupId: groupId,
                parentGroupId: parentGroupId,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    GroupModalController,
    GroupModal,
};
